import { put, select } from "redux-saga/effects";
import { actions } from "../../actions";
import { deletePaymentMethod } from "../../../../api/v1/book/payment-methods/deletePaymentMethod";
import {
  getSelectedPaymentMethodId,
  getRewardsPaymentAccountReferenceId,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";

export function* deletePaymentMethodSaga({
  paymentId,
}: actions.IDeletePaymentMethod) {
  try {
    const state: IStoreState = yield select();

    yield deletePaymentMethod({ paymentId });
    yield put(actions.deletePaymentMethodCallStateSuccess());

    const selectedPaymentMethodId = getSelectedPaymentMethodId(state);
    const paymentMethodRewardsAccountId =
      getRewardsPaymentAccountReferenceId(state);
    if (selectedPaymentMethodId === paymentId) {
      yield put(
        actions.setSelectedPaymentMethodId({
          paymentMethodId: "",
          accountId: paymentMethodRewardsAccountId || undefined,
        })
      );
    }

    yield put(actions.listPaymentMethods());
  } catch (e) {
    yield put(actions.deletePaymentMethodCallStateFailed());
  }
}
